import React from 'react';

const COLORS = [
  // Yellows (lightest to darkest)
  { name: 'yellow1', value: '#fddf6d' },
  { name: 'yellow2', value: '#fddc5e' },
  { name: 'yellow3', value: '#fdd84c' },
  { name: 'yellow4', value: '#fed242' },
  { name: 'yellow5', value: '#ffc933' },
  // Oranges (lightest to darkest)
  { name: 'orange1', value: '#ffb74d' },
  { name: 'orange2', value: '#f2af17' },
  { name: 'orange3', value: '#eda845' },
  { name: 'orange4', value: '#ea9a26' },
  { name: 'orange5', value: '#e68b07' },
  { name: 'orange6', value: '#dc8507' },
  // Greys
  { name: 'grey', value: '#e6e6e6' },
  { name: 'grey1', value: '#dad9d9' },
  { name: 'grey15', value: '#f1f1f1' },
  { name: 'grey2', value: '#b3b0b0' },
  { name: 'grey25', value: '#ddd' },
  { name: 'grey3', value: '#757575' },
  { name: 'grey4', value: '#515151' },
  { name: 'grey5', value: '#343434' },
  { name: 'grey6', value: '#262626' },
  { name: 'grey7', value: '#171717' },
  // Whites
  { name: 'white', value: '#fefefe' },
  { name: 'offWhite', value: '#f3f3f3' },
  // Blues
  { name: 'blue1', value: '#e3f0fc' },
  { name: 'blue2', value: '#90caf9' },
  { name: 'blue3', value: '#1976d2' },
  { name: 'infoBlue', value: '#2196f3' },
  // Teals (light to dark, complimenting teal3)
  { name: 'teal1', value: '#4db6ac' }, // light, fresh teal
  { name: 'teal2', value: '#008080' }, // classic teal
  { name: 'teal3', value: '#054a57' }, // deep, dark teal
];

const UserGrid = () => (
  <div style={{ padding: '2rem' }}>
    <h1 style={{ marginBottom: '2rem' }}>All Theme Colours</h1>
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '2rem',
        alignItems: 'center',
      }}
    >
      {COLORS.map((color) => (
        <div
          key={color.name}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '90px',
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: color.value,
              border: '2px solid #eee',
              boxShadow: '0 2px 8px #0001',
              marginBottom: 8,
            }}
            title={color.value}
          />
          <span style={{ fontSize: 13, color: '#444', textAlign: 'center' }}>
            {color.name}
          </span>
          <span style={{ fontSize: 11, color: '#888' }}>{color.value}</span>
        </div>
      ))}
    </div>
  </div>
);

export default UserGrid;
